import type { CapabilityTrace } from '../libs/velis-capability'

import { defineStore } from 'pinia'
import { ref } from 'vue'

const traceLimit = 8

/**
 * Keeps the latest capability traces for the workbench.
 * The stage window records them. `state: true` copies the list to the settings window.
 * A remote snapshot replaces the list. This store has no watcher that writes it again.
 */
export const useVelisCapabilityTraceStore = defineStore('velis-capability-trace', () => {
  const traces = ref<CapabilityTrace[]>([])

  function replace(next: readonly CapabilityTrace[]) {
    traces.value = next.slice(0, traceLimit)
  }

  return { replace, traces }
}, {
  synced: {
    state: true,
  },
})
